export default __webpack_public_path__ + "static/media/DJI_0972.MP4.00_00_12_14.Still001.3de953ff.jpg";